/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SimplePatient } from './SimplePatient';
import type { Specimen } from './Specimen';
import type { UserContact } from './UserContact';
import type { UserName } from './UserName';

export type Cases = {
    readonly id?: number;
    patient: SimplePatient;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    readonly collected_date_offset?: string;
    readonly collected_date_timezone?: string;
    readonly created_at?: string;
    readonly updated_at?: string;
    /**
     * WPL's accession value
     */
    accession?: string | null;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    ordering_doctor: UserContact;
    readonly slides_count?: number;
    /**
     * date/time that we received a WPL order message indicating grossing was completed. This will match the order_message FK.
     */
    gross_completed?: string | null;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    priority?: Cases.priority;
    readonly slide_status?: string;
    /**
     * current workflow status of the case
     */
    status?: Cases.status;
    active_assignment: UserName;
    readonly screen_assignment_id?: number;
    readonly finalize_assignment_id?: number;
    is_screening?: boolean;
    is_request_screen_complete?: boolean;
    is_manually_accessioned?: boolean | null;
    specimens: Array<Specimen>;
    readonly diagnosis_categories?: string;
    readonly high_res_removal_date?: string;
    readonly finalized_report_id?: number;
    working_reasons: any;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    readonly received_date_offset?: string;
    readonly received_date_timezone?: string;
    /**
     * case origin, WPL or PW LIS
     */
    source?: Cases.source;
    /**
     * Order id get from order message from third party, e.g. ModMed
     */
    external_order_id?: string | null;
    /**
     * EZDerm's order id that, with patient name, matches the case in their system
     */
    external_ezderm_order_id?: string | null;
    readonly can_correct_report?: string;
}

export namespace Cases {

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
    }


}
